import { Dispatch, FC, SetStateAction } from 'react';
import PageControls from './page-controls/PageControls';
import PageSizeDropdown from './page-size-dropdown/PageSizeDropdown';
import ResultText from './result-text/ResultText';

type PaginationProps = {
  pageSize: number;
  setPageSize: Dispatch<SetStateAction<number>>;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  count: number;
  totalCount: number;
  isHeader?: boolean;
  textValue?: string;
  textFont?: number;
  textFontWeight?: number;
  textMarginTop?: number;
  hideResultsText?: boolean;
};

const PaginationContainer: FC<PaginationProps> = (props) => {
  return (
    <div className={`pagination-container ${props.count < 10 ? 'results-text' : ''}`}>
      {props.count > 10 && <PageControls {...props} />}
      {props.count > 10 && <PageSizeDropdown {...props} />}
      {!props.hideResultsText && <ResultText {...props} />}
    </div>
  );
};

export default PaginationContainer;
